/* pd-r18 — Apple design pass, round 4 (18 Oct 2026).
   1. Swipe a product card's photo sideways to see its second photo (phones can't hover).
   2. A soft blurred preview shows while each product photo loads.
   4. The bag's "Remove" link gets the same 5-second Undo as the swipe. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var coarse = matchMedia('(pointer: coarse)');

  /* ---------- 1. Swipe a card for its second photo ---------- */
  function dots(link) {
    if (link.querySelector('.pd-r18-dots')) return;
    var d = document.createElement('span');
    d.className = 'pd-r18-dots'; d.setAttribute('aria-hidden', 'true');
    d.innerHTML = '<i class="on"></i><i></i>';
    link.appendChild(d);
  }
  function secImg(link) { return link.querySelector('.product-item__image-figure--secondary img'); }
  function ready(img) { return img && img.complete && img.naturalWidth > 0; }
  function warm(link) {                                              // start loading the second photo before anyone swipes
    var img = secImg(link); if (!img || ready(img) || img.dataset.pdR18Warm) return;
    img.dataset.pdR18Warm = '1'; img.loading = 'eager';
    var s = img.getAttribute('srcset'); if (s) { img.removeAttribute('srcset'); img.setAttribute('srcset', s); }
    img.addEventListener('load', function () { img.parentNode.classList.add('lazyloaded'); }, { once: true });
  }
  function paintDots(link, on) {
    var i = link.querySelectorAll('.pd-r18-dots i');
    if (i.length === 2) { i[0].classList.toggle('on', !on); i[1].classList.toggle('on', on); }
  }
  function setAlt(link, on) {
    var img = secImg(link);
    if (on && !ready(img)) {                                          // never blank the card: wait for the second photo
      warm(link);
      if (img) img.addEventListener('load', function () { if (link.dataset.pdR18Want === '1') setAlt(link, true); }, { once: true });
      link.dataset.pdR18Want = '1';
      return;
    }
    link.dataset.pdR18Want = on ? '1' : '0';
    if (on && img) img.parentNode.classList.add('lazyloaded');
    link.classList.toggle('pd-r18-alt', on);
    paintDots(link, on);
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { warm(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '200px 0px' }) : null;
  function cards() {
    if (!coarse.matches) return;
    document.querySelectorAll('.product-item__image--has-secondary').forEach(function (link) {
      if (link.dataset.pdR18) return;
      link.dataset.pdR18 = '1';
      dots(link);
      if (io) io.observe(link); else warm(link);
    });
  }
  var sw = null, swallowLink = null;
  document.addEventListener('pointerdown', function (e) {
    if (!coarse.matches || e.pointerType === 'mouse') return;
    var link = e.target.closest('.product-item__image--has-secondary'); if (!link) return;
    sw = { link: link, id: e.pointerId, x0: e.clientX, y0: e.clientY, t0: e.timeStamp, live: false };
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (!sw || e.pointerId !== sw.id || sw.live) return;
    var dx = e.clientX - sw.x0, dy = e.clientY - sw.y0;
    if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
    if (Math.abs(dy) * 2 > Math.abs(dx)) { sw = null; return; }         // anything not clearly sideways is a scroll
    sw.live = true;
  }, { passive: true });
  function swEnd(e) {
    if (!sw || e.pointerId !== sw.id) return;
    var s = sw; sw = null; if (!s.live || e.type === 'pointercancel') return;
    var dx = e.clientX - s.x0, v = dx / Math.max(1, e.timeStamp - s.t0) * 1000;
    if (Math.abs(dx) < 40 && Math.abs(v) < 500) return;
    setAlt(s.link, dx < 0);                                            // swipe left = second photo, right = first
    swallowLink = s.link; setTimeout(function () { swallowLink = null; }, 400);
  }
  document.addEventListener('pointerup', swEnd, { passive: true });
  document.addEventListener('pointercancel', swEnd, { passive: true });
  document.addEventListener('click', function (e) {                    // a swipe never opens the product
    if (swallowLink && swallowLink.contains(e.target)) { e.preventDefault(); e.stopPropagation(); swallowLink = null; }
  }, true);

  /* ---------- 2. Blurred preview while photos load ---------- */
  function tiny(src) {
    if (!src || src.indexOf('/cdn/shop/') < 0 && src.indexOf('cdn.shopify.com') < 0) return null;
    var u = src.replace(/([?&])width=\d+/, '$1width=24');
    if (u === src) u = src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=24';
    return u;
  }
  function lqip(root) {
    (root || document).querySelectorAll('.lazy-image:not(.lazyloaded):not([data-pd-r18])').forEach(function (fig) {
      fig.setAttribute('data-pd-r18', '1');
      var img = fig.querySelector('img'); if (!img || (img.complete && img.naturalWidth > 0)) return;
      var u = tiny(img.getAttribute('src') || img.currentSrc); if (!u) return;
      var p = document.createElement('span');
      p.className = 'pd-r18-lqip'; p.setAttribute('aria-hidden', 'true');
      p.style.backgroundImage = 'url("' + u.replace(/"/g, '%22') + '")';
      fig.insertBefore(p, fig.firstChild);
      img.addEventListener('load', function () { setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 500); }, { once: true });
    });
  }

  /* ---------- 4. Undo for the bag's Remove link ---------- */
  var snap = {};
  function snapshot() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      snap = {}; c.items.forEach(function (it) { snap[it.key] = it; });
    }).catch(function () {});
  }
  function refreshBag() {
    return fetch('?section_id=helper-cart').then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var form = document.getElementById('AjaxCartForm'), nf = doc.getElementById('AjaxCartForm'), ns = doc.getElementById('AjaxCartSubtotal');
      if (!form || !nf) { location.reload(); return; }
      form.innerHTML = nf.innerHTML;
      if (form.ajaxifyCartItems) form.ajaxifyCartItems();
      var count = form.querySelector('[data-cart-count]'), total = form.querySelector('[data-cart-total]');
      document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { if (count) el.textContent = count.textContent; });
      document.querySelectorAll('[data-header-cart-total]').forEach(function (el) { if (total) el.textContent = total.textContent; });
      var sub = document.getElementById('AjaxCartSubtotal'); if (sub && ns) sub.innerHTML = ns.innerHTML;
      form.dispatchEvent(new Event('cart-updated'));
      snapshot();
    });
  }
  var bar = null, timer = null;
  function showUndo(line) {
    var sb = document.getElementById('site-cart-sidebar'); if (!sb) return;
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'pd-r17-undo pd-r18-undo';                        // same look as the swipe's Undo bar
      bar.setAttribute('role', 'status');
      bar.innerHTML = '<span></span><button type="button">Undo</button>';
      bar.querySelector('button').addEventListener('click', function () {
        var l = bar._line; if (!l) return; bar._line = null; hide();
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: l.variant_id, quantity: l.quantity, properties: l.properties || {} }] })
        }).then(refreshBag);
      });
    }
    if (bar.parentNode !== sb) sb.appendChild(bar);
    bar._line = line;
    bar.querySelector('span').textContent = 'Removed ' + (line.product_title || 'item');
    bar.offsetWidth; bar.classList.add('is-on');
    clearTimeout(timer); timer = setTimeout(hide, 5000);
  }
  function hide() { if (bar) bar.classList.remove('is-on'); clearTimeout(timer); }
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;                                          // the swipe (pd-r17) clicks Remove itself and shows its own Undo
    var rm = e.target.closest('#site-cart-sidebar .cart-item .remove'); if (!rm) return;
    var item = rm.closest('.cart-item'), line = item && snap[item.dataset.id];
    if (line) setTimeout(function () { showUndo(line); }, 300);
  }, true);
  function watchBag() {                                                // keep a copy of the bag so Undo knows what was removed
    var sb = document.getElementById('site-cart-sidebar'); if (!sb || sb._pdR18) return;
    sb._pdR18 = true;
    new MutationObserver(function () { if (sb.classList.contains('sidebar--opened')) snapshot(); })
      .observe(sb, { attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('cart-updated', snapshot, true);

  function init() { cards(); lqip(); watchBag(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);
  var later = 0;
  new MutationObserver(function (ms) {                                 // new cards from filters or "load more"
    for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { clearTimeout(later); later = setTimeout(init, 150); break; }
  }).observe(document.body, { childList: true, subtree: true });
})();
